import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KasseComponent } from './kasse/kasse.component';
import { ForestillingComponent } from './forestilling/forestilling.component';


const routes: Routes = [
  { 
    path: 'kasse',
    component: KasseComponent
  },
  {
    path: 'forestilling/:id',
    component: ForestillingComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SalgRoutingModule { }
